import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  imageViewerWrapper: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
  },

  imageContainer: {
    maxWidth: `calc(min(90vw, ${theme.breakpoints.values.md - 240}px))`,
    maxHeight: `calc(min(90vh, ${theme.breakpoints.values.md - 160}px))`,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'grab',

    '& img': {
      maxHeight: '100%',
      maxWidth: '100%',
    },
  },
}));
